import axios from 'axios';
import config from '../config';

const instance = axios.create({
  baseURL: config.apiBaseUrl,
  maxBodyLength: Infinity,
  maxContentLength: Infinity,
});

const isFormData = (data) => typeof FormData !== 'undefined' && data instanceof FormData;

const unsetContentType = (headers) => {
  if (!headers) return;
  if (typeof headers.delete === 'function') {
    headers.delete('Content-Type');
    headers.delete('content-type');
  } else {
    delete headers['Content-Type'];
    delete headers['content-type'];
  }
  // Axios 1: false skips the default JSON Content-Type so the browser can set the multipart boundary.
  if (typeof headers.set === 'function') {
    headers.set('Content-Type', false);
  } else {
    headers['Content-Type'] = false;
  }
};

instance.interceptors.request.use((configReq) => {
  const headers = configReq.headers ?? {};
  configReq.headers = headers;

  const token = localStorage.getItem('token');
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (isFormData(configReq.data)) {
    unsetContentType(headers);
  } else {
    headers['Content-Type'] = 'application/json';
  }

  return configReq;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default instance;
